//изображение бэкграундом
function ibgLearn() {
  let ibg = document.querySelectorAll(".ibg");
  for (let i = 0; i < ibg.length; i++) {
    if (ibg[i].querySelector("img")) {
      ibg[i].style.backgroundImage =
        "url(" + ibg[i].querySelector("img").getAttribute("src") + ")";
    }
  }
}

ibgLearn();

// BTN LOAD MORE
let offsetLearn;
let containerForBtnLearn = document.querySelector("#more_learn");
let btnLoadMoreLearn = document.querySelector("#btn_more_learn");

if (typeof btnLoadMoreLearn != "undefined" && btnLoadMoreLearn != null) {
  btnLoadMoreLearn.addEventListener("click", function () {
    offsetLearn = btnLoadMoreLearn.getAttribute("data-offset");
    let dataProduct = btnLoadMoreLearn.getAttribute("data-product");
    let dataCategory = btnLoadMoreLearn.getAttribute("data-category");
    let dataUrl = btnLoadMoreLearn.getAttribute("data-url");
    getDataLern(offsetLearn, dataProduct, dataCategory, dataUrl);
  });
}

function getDataLern(offset, product, category, urlRequest) {
  const request = new XMLHttpRequest();
  const url = urlRequest;
  const params =
    "offset=" +
    offset +
    "&product=" +
    product +
    "&category=" +
    category +
    "&_csrf=" +
    jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
        let response = JSON.parse(request.responseText);
        document.querySelector(".items-block.learn").insertAdjacentHTML( 'beforeend', response.html );
        ibg();
        checkCategories();
        addListenerForCat();
        if (
          response.showLoadMore === false ||
          response.showLoadMore === "false"
        ) {
          containerForBtnLearn.classList.add("hide");
        } else {
          btnLoadMoreLearn.setAttribute("data-offset", response.offset);
        }
      } else {
        window.location.href = "/404";
      }
    }
  });
  request.send(params);
}
function processResponse(response) {
  for (let item in response) {
    createBlockLearn(response[item]);
  }
}

function createBlockLearn(item) {
  let htmlForBlock =
    `
    <div class="block-item">
    ` +
    checkVideoLearn(item.video, item.image) +
    `
    <div class="block-item__body">
      <div class="item_learn_category_btn">
        <a href="` +
    getFirstCategoryUrl(item.categories) +
    `" class="block-item__link first_category"
    onmouseover="hoverColorEl(this, '#ffffff')"
    onmouseout="hoverColorEl(this, '` +
    productColor +
    `')"
    style="color: ` +
    productColor +
    `">` +
    getFirstCategoryName(item.categories) +
    `</a
        >
        ` +
    getCategoriesInBlock(item.categories) +
    `
      </div>
      <div class="block-item__title"
      onmouseover="hoverColorEl(this, '#ffffff')"
      onmouseout="hoverColorEl(this, '` +
    productColor +
    `')"
      style="color: ` +
    productColor +
    `">
        ` +
    item.title +
    `
      </div>
    </div>
  </div>
  `;
  let mainLearnBlock = document.querySelector(".items-block");
  mainLearnBlock &&
    mainLearnBlock.insertAdjacentHTML("beforeend", htmlForBlock);
}
function checkVideoLearn(video, image) {
  if (video) {
    return (
      `<div
    class="block-item__image ibg watch_video_modal"
    data-video-link="` +
      video +
      `"
  >
    <img src="` +
      image +
      `" alt="" />
    <div class="item__image-link"></div>
  </div>`
    );
  } else {
    return (
      `<div
    class="block-item__image ibg"
  >
    <img src="` +
      image +
      `" alt="" />
  </div>`
    );
  }
}
function getFirstCategoryName(arrCategories) {
  if (arrCategories.length != 0) {
    return arrCategories[0].title;
  }
}
function getFirstCategoryUrl(arrCategories) {
  if (arrCategories.length != 0) {
    return arrCategories[0].url;
  }
}
function getCategoriesInBlock(arrCategories) {
  let rezBlock = "";
  arrCategories.shift();
  if (arrCategories.length > 1) {
    for (let itemCategory of arrCategories) {
      rezBlock +=
        `<a class="block-item__link" href="` +
        itemCategory.url +
        `">` +
        itemCategory.title +
        `</a>` +
        "\n";
    }
    return (
      ` <div class="dropup_category">
     <img
       class="dropbtn_category"
       src="images/notes/notes_aside_arrow.svg"
       alt=""
     />
     <div class="dropup_category_content">
       ` +
      rezBlock +
      `
     </div>
   </div>`
    );
  } else {
    return "";
  }
}
// CHECK CONTAINER WITH CATEGORIES
// HIDE BLOCK IF BLOCK WITH CATEGORIES IS EMPTY

function checkCategories() {
  for (let item of document.querySelectorAll(".dropup_category")) {
    if (!item.querySelector(".dropup_category_content").hasChildNodes()) {
      item.querySelector(".dropbtn_category").classList.add("hide");
    }
  }
}

// ADD LISTENER FOR CATEGORY ARROWS
function addListenerForCat() {
  if (checkMobDevice()) {
    for (let btnArrowCat of document.querySelectorAll(".dropup_category")) {
      btnArrowCat.addEventListener("click", function () {
        toggleCategoryBlock(btnArrowCat);
      });
    }
  }
}
function toggleCategoryBlock(el) {
  el.querySelector(".dropup_category_content").classList.toggle("active");
  el.querySelector(".dropbtn_category").classList.toggle("rotate_arrow");
}
checkCategories();
addListenerForCat();
